import { Box, Stack, styled } from "@mui/material";
import ButtonDisabled from "images/button-disabled.svg";
import ButtonIdleActive from "images/button-idle-active.svg";
import ButtonIdleHover from "images/button-idle-hover.svg";
import ButtonIdle from "images/button-idle.svg";
import ButtonSuccess from "images/button-success.svg";

export const Container = styled(Stack)`
  position: relative;
  padding: 5px;
  width: 130px;
  height: fit-content;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 4px;

  border-radius: 15px;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  border: 1px solid #f1f1f1;
  background: rgba(234, 235, 239, 0.4);

  box-sizing: border-box;
`;
export const ButtonContainer = styled(Stack)`
  position: relative;
  width: 120px;
  height: 120px;

  justify-content: center;
  align-items: center;
  gap: 0;

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 30px;
`;

export const LogoSplash = styled(Stack)`
  width: 45px;
  height: 45px;

  justify-content: center;
  align-items: center;

  background-color: transparent;
  border-radius: 50%;
  overflow: hidden;
`;

export const Logo = styled(Box)`
  width: 90px;
  height: 45px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;

  cursor: pointer;
  border-radius: 6px;
`;

export const HalfHolder = styled(Stack)`
  position: absolute;
  top: 6px;
  left: 8px;
  right: 8px;
  height: 60px;

  justify-content: center;
  align-items: center;

  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  overflow: hidden;

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  user-select: none;
`;

export const Led = styled(Box)`
  margin-top: 1.631px;
  margin-bottom: 1px;
  height: 14px;
  width: 4.89px;

  background-color: darkgrey;
  border-radius: 3px;

  &.idle {
    background-color: lightgrey;
  }

  &.disabled {
    background-color: lightgrey;
  }

  &.error {
    background-color: red;
  }

  &.success {
    background-color: #72ff13;
  }

  border: 1px solid darkgrey;
  z-index: 10;
`;

export const LogoHolder = styled(LogoSplash)`
  color: grey;
  background-color: #fff;
`;

export const EmptyLogoHolder = styled(Stack)`
  flex: 0 0 auto;
  width: 45px;
  height: 45px;

  justify-content: center;
  align-items: center;

  background-color: transparent;
  border-radius: 50%;
  overflow: hidden;

  user-select: none;
`;

export const TextMosaic = styled(Box)`
  width: 140px;
  height: 140px;

  font-size: 6px;
  font-weight: 600;

  overflow-wrap: anywhere;
  word-wrap: anywhere;

  transform: rotate(-10deg);
`;

export const ButtonIndicator = styled(Stack)`
  width: 45px;
  height: 45px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  cursor: pointer;
  user-select: none;

  &.idle {
    background-image: url(${ButtonIdle});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  &.idle:hover,
  &.success:hover {
    background-image: url(${ButtonIdleHover});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  &.idle:active {
    background-image: url(${ButtonIdleActive});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  &.success {
    background-image: url(${ButtonSuccess});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  &.disabled {
    background-image: url(${ButtonDisabled});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  z-index: 10;
`;

export const Prop = styled(Stack)`
  flex-direction: row;
  justify-content: flex-start;
  gap: 5px;
`;

export const Label = styled(Box)`
  font-family: sans-serif;
  font-size: 10px;
  color: #9a9ea5;
`;

export const Value = styled(Box)`
  flex: 1 1 auto;
  font-family: sans-serif;
  font-size: 10px;
  color: #272727;
  text-align: left;
  overflow-wrap: anywhere;
  word-wrap: anywhere;
`;
